/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

// import { FeatureWebpageImage } from "./feature-webpage-image";
import { WebpageImage } from "cms/images/webpage-image";

const Webpage = (props) => {
    
    const webpage = props?.webpage;
    const webpageCard = props?.webpageCard;
    const total = props?.total;
    
    const webpage_guid = webpage?.webpage;
    const title = webpage?.title;
    const description = webpage?.description;

    return (
        <div className={`feature-webpage-content total_${webpageCard}_${total % 3}`}>
            
            <WebpageImage
                webpage_guid={webpage_guid}
            />
            <h4>{title}</h4>
            <p>{description}</p>
        </div>
    );
};

export { Webpage };


/**
 * @typedef {object} WebpageProps
 * @property {FeaturedWebpage=} web
 * @property {string} webpageCard
 * @property {number} total
 */

/**
 * @typedef {object} FeaturedWebpage
 * @property {string} guid - Unique identifier for the featured webpage.
 * @property {string} webpage - Webpage associated with the featured webpage.
 * @property {number} position - Position of the featured webpage.
 * @property {string} title - Title of the featured webpage.
 * @property {string} description - Description of the featured webpage.
 * @property {string} image - Identifier for the associated image.
 */

/**
 * @typedef {Object} WebpageResponse
 * @property {number} id - Identifier for the webpage.
 * @property {string} guid - Unique identifier for the webpage.
 * @property {string} website - Website associated with the webpage.
 * @property {string} type - Type of the webpage.
 * @property {string} model - Model associated with the webpage.
 * @property {string} parent - Parent identifier for the webpage.
 * @property {string} nav_title - Title of the webpage for navigation.
 * @property {string} description - Description of the webpage.
 * @property {string} slug - Slug for the webpage.
 * @property {string} path - Path to the webpage.
 * @property {string|null} keywords - Keywords associated with the webpage (can be null).
 * @property {string} shortlink - Shortlink identifier for the webpage.
 * @property {string|null} nav_image - Navigation image associated with the webpage (can be null).
 * @property {string} nav_icon - Icon identifier for the webpage navigation.
 * @property {string} created_at - The date and time when the webpage was created.
 * @property {string} updated_at - The date and time when the webpage was last updated.
 * @property {string} updated_by - Identifier of the user who last updated the webpage.
 * @property {string} created_by - Identifier of the user who created the webpage.
 * @property {number} hide_in_nav - Flag indicating whether the webpage should be hidden in navigation (0 or 1).
 */

/**
 * @typedef {Object} ModelResponse
 * @property {string} guid
 * @property {string} title
 * @property {string} description
 */
